import { Link } from 'react-router';
import { Logo } from '../brand/Logo';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import './Page.css';

export function Home() {
  useDocumentTitle('');
  return (
    <div className="page-hero">
      <Logo size={96} title={null} />
      <h1 className={`wordmark page-heroTitle`}>Halvard</h1>
      <p className="page-tagline">A Viking battle on a melting lake.</p>
      <p className="page-lead">
        Shove the enemy through the ice and take the three runestones before the thaw. Every lake is
        new, so there is no opening to learn by heart.
      </p>
      <div className="page-actions">
        <Link to="/play/local" className="btn btn-primary">
          Play on this screen
        </Link>
        <Link to="/play/online" className="btn">
          Play a friend online
        </Link>
        <Link to="/play/bot" className="btn">
          Play the bot
        </Link>
        <Link to="/learn" className="btn">
          Learn the rules
        </Link>
      </div>
      <p className="page-note">
        The first Halvard game, on a mountain, is still <Link to="/mountain">here</Link>, with its
        bots.
      </p>
    </div>
  );
}
